import React, { useState } from 'react';
import { articleCountry } from 'utils/currentLanguage';
import qs from 'qs';

export const CountryContext = React.createContext();

export const CountryProvider = ({ children }) => {
  const queryValues = qs.parse(window.location.search, {
    ignoreQueryPrefix: true,
  });
  const countryQuery = queryValues.country && queryValues.country.split('_')[0];
  const [currentCountry, setCurrentCountry] = useState(
    countryQuery || articleCountry
  );
  const [countryHash, setCountryHash] = useState(countryQuery);

  return (
    <CountryContext.Provider
      value={{
        countryHash,
        setCountryHash,
        currentCountry,
        setCurrentCountry,
      }}
    >
      {children}
    </CountryContext.Provider>
  );
};



// WEBPACK FOOTER //
// ./src/context/CountryContext.js